/**
 * 10.9GZ — ROTAÇÃO da prévia 3D (Bolsa, Personagem, Roupa): gira sozinha devagar e o dedo arrasta
 * pra girar (pointer capture). A tela dona chama `tick(dt)` pra receber o ângulo e `bind(canvas)`
 * uma vez por canvas. O render em si é do Renderer.renderPreview (chamado pelo Game no loop).
 */
import { reducedMotion } from "./motion";

export class PreviewRotor {
  private ang = 0.6;
  private dragX = 0;
  private dragging = false;
  private idle = 0;

  tick(dt: number): number {
    if (!this.dragging) {
      this.idle += dt;
      if (this.idle > 1.2 && !reducedMotion()) this.ang += dt * 0.55;
    }
    return this.ang;
  }

  bind(cv: HTMLCanvasElement): void {
    cv.onpointerdown = (e) => { this.dragging = true; this.dragX = e.clientX; cv.setPointerCapture(e.pointerId); };
    cv.onpointermove = (e) => { if (!this.dragging) return; this.ang += (e.clientX - this.dragX) * 0.012; this.dragX = e.clientX; };
    cv.onpointerup = cv.onpointercancel = () => { this.dragging = false; this.idle = 0; };
  }
}

/** Contrato que o Game usa pra alimentar a prévia de uma tela aberta. */
export interface PreviewHost {
  readonly isOpen: boolean;
  readonly previewCanvas: HTMLCanvasElement | null;
  tickPreview(dt: number): number;
}
